export default __webpack_public_path__ + "static/media/edit.d4800e3b.svg";